// extracted by mini-css-extract-plugin
module.exports = {"container":"Intro_container__oCjZ6","title":"Intro_title__2_Vkb"};